import PropTypes from 'prop-types';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Captcha from '../forms/Captcha/Captcha';

const FormItem = Form.Item;

function LoginFormPassword(props) {
  const { preLogin, mallType } = props;

  const [form] = Form.useForm();
  const { replace } = useHistory();
  const [loading, setLoading] = useState(false);

  function handleSubmit() {
    form.validateFields().then((values) => {
      setLoading(true);
      preLogin({ ...values, mallType: mallType })
        .then((res) => {
          if (res[0].data.pwdUpdateDate === null) {
            replace('/user/changePassword');
            return;
          }
          replace('/commerce/platform', { mallType });
        })
        .catch(() => {
          setLoading(false);
          form.resetFields(['captcha']);
        });
    });
  }

  return (
    <Form form={form}>
      <Form.Item name="username" rules={[{ required: true, message: '请输入用户名' }]}>
        <Input
          placeholder="请输入用户名"
          prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          allowClear
        />
      </Form.Item>
      <FormItem name="password" rules={[{ required: true, message: '请输入登录密码' }]}>
        <Input.Password
          placeholder="请输入密码"
          prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
        />
      </FormItem>

      <FormItem
        name="captcha"
        rules={[
          { required: true, message: '请完成滑块验证' },
          { type: 'enum', enum: ['success'], message: '验证失败, 请重新验证' },
        ]}
        initialValue="fail"
      >
        <Captcha onSuccess={handleSubmit} />
      </FormItem>

      <Button block type="primary" loading={loading} onClick={handleSubmit}>
        登录
      </Button>
    </Form>
  );
}

const mapDispatchToProps = (dispatch) => ({
  preLogin: dispatch.login.preLogin,
});
LoginFormPassword.propTypes = {
  redirectUrl: PropTypes.string,
  preLogin: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(LoginFormPassword);
